//提前加载图片
const preloadImages = () => {
    for(let i=1;i<50;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_new_${i}.avif`;
    }
};
preloadImages()

$(function(){
    setTimeout(() => {
        $('.box1_title').addClass('showup')
    }, 500);
})

// 获取根元素的字体大小
let rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
var remValue = -3.75 * rootFontSize;

if(window.innerWidth>750){
    var box2T = '0',box8O = rootFontSize * 21.5
    $('.box2_items div').hover(function(){
        $('.box2_items div').removeClass('box2_active')
        $(this).addClass('box2_active')
    })
}else{
    $('.box2_items div').removeClass('box2_active')
    box2T = 'onenter',box8O = -30
}


let controller1 = new ScrollMagic.Controller();

let scene2 = new ScrollMagic.Scene({
    offset: -20,
    triggerElement: '.box2_1',
    triggerHook: box2T,
    duration:1000,
})
if(window.innerWidth>750){
    scene2.setPin('.box2_1')
    scene2.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        if(index>5){
            if(index<60){
                $('.box2_content').css({background:`rgba(0,0,0,${mapValue(index,5,60,0,0.8)})`})
                $('.box2_content div').removeClass('showup')
            }else{
                $('.box2_content').css({background:`rgba(0,0,0,0.8)`})
                $('.box2_content div').addClass('showup')
            }
        }else{
            $('.box2_content').css({background:`rgba(0,0,0,0)`})
        }
    })
}else{
    scene2.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        if(index>10){
            $('.box2_content div').addClass('showup')
        }else{
            $('.box2_content div').removeClass('showup')
        }
    })
}


let scene3 = new ScrollMagic.Scene({
    offset: 30,
    triggerElement: '.box3',
    triggerHook: '0',
    duration:600,
})
if(window.innerWidth>750){
    scene3.setPin('.box3')
}


let scene4 = new ScrollMagic.Scene({
    offset: -50,
    triggerElement: '.box4',
    triggerHook: "0",
    duration:5000,
})
scene4.setPin('.box4')
scene4.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    if(index<50){
        for(let i=1;i<16;i++){
            if(index>i*2){
                $('.box4_img').attr('src',`https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_new_${i}.avif`)
            }
        }
    }else{
        for(let i=16;i<50;i++){
            if(index-50>(i-15)*1){
                $('.box4_img').attr('src',`https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_new_${i}.avif`)
            }
        }
    }
    
    
    if(index>30){
        //30 50 85
        $('.box4_title').addClass('showup')
        if(index>50){
            $('.box4_title').removeClass('showup')
            if(index>85){
                $('.box4_content').addClass('showup')
                $('.box4_line').css({height:'100%'})
                $('.box4_video').css({opacity:'1'})
            }else{
                $('.box4_content').removeClass('showup')
                $('.box4_line').css({height:'0%'})
                $('.box4_video').css({opacity:'0'})
            }
        }
    }else{
        $('.box4_title').removeClass('showup')
    }
})


let scene4_1 = new ScrollMagic.Scene({
    offset: 100,
    triggerElement: '.box4_1',
    triggerHook: 'onenter',
    duration:0,
})
if(window.innerWidth<750){
    scene4_1.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        $('.box4_title1').addClass('showup')
        if(index<2){
            $('.box4_title1').removeClass('showup')
        }
    })
}


let scene5 = new ScrollMagic.Scene({
    offset: -40,
    triggerElement: '.box5',
    triggerHook: '0',
    duration:2500,
})
scene5.setPin('.box5')
scene5.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    if(index>10){
        $('.box5_img').css({opacity:'1'})
        $('.box5_title').addClass('showup')
        $('.box5_info1').addClass('showup')
        if(index>30){
            $('.box5_info1').removeClass('showup')
            $('.box5_info2').addClass('showup')
            $('.box5_bg').show()
            $('.box5_bg div').hide()
            $(`.box5_bg div:nth-child(1)`).show()
            $('.box5_info2 div').removeClass('box5_active')
            $(`.box5_info2 div:nth-child(1)`).addClass('box5_active')
            if(index>50){
                $('.box5_bg div').hide()
                $(`.box5_bg div:nth-child(2)`).show()
                $('.box5_info2 div').removeClass('box5_active')
                $(`.box5_info2 div:nth-child(2)`).addClass('box5_active')
                if(index>70){
                    $('.box5_bg div').hide()
                    $(`.box5_bg div:nth-child(3)`).show()
                    $('.box5_info2 div').removeClass('box5_active')
                    $(`.box5_info2 div:nth-child(3)`).addClass('box5_active')
                }
            }
        }else{
            $('.box5_info2').removeClass('showup')
            $('.box5_bg').hide()
        }
    }else{
        $('.box5_img').css({opacity:'0'})
        $('.box5_title').removeClass('showup')
        $('.box5_info1').removeClass('showup')
    }
})


let scene6 = new ScrollMagic.Scene({
    offset: -80,
    triggerElement: '.box6',
    triggerHook: 'onenter',
    duration:600,
})
scene6.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    if(index>10){
        $('.box6_img').css({transform:`scale(0.8)`})
        if(index>60){
            $('.box6_title').addClass('showup')
        }else{
            $('.box6_title').removeClass('showup')
        }
    }else{
        $('.box6_img').css({transform:`scale(1)`})
    }
})


let scene7_1 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box7_1',
    triggerHook: 'onenter',
    duration:0,
})
scene7_1.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box7_1 img').addClass('showup')
    if(index<2){
        $('.box7_1 img').removeClass('showup')
    }
})


let scene7 = new ScrollMagic.Scene({
    offset: -80,
    triggerElement: '.box7',
    triggerHook: box2T,
    duration:1500,
})
if(window.innerWidth>750){
    scene7.setPin('.box7')
    scene7.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        if(index>10){
            $('.box7_title').addClass('showup')
            if(index>30){
                $('.box7_text').addClass('showup')
                if(index>70){
                    $('.box7_img2').css({opacity:'1'})
                }else{
                    $('.box7_img2').css({opacity:'0'})
                }
            }else{
                $('.box7_text').removeClass('showup') 
            }
        }else{
            $('.box7_title').removeClass('showup')
        }
    })
}else{
    scene7.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        if(index>10){
            $('.box7_title').addClass('showup')
            $('.box7_text').addClass('showup')
        }else{
            $('.box7_title').removeClass('showup')
            $('.box7_text').removeClass('showup') 
        }
    })
}


let scene8 = new ScrollMagic.Scene({
    offset: box8O,
    triggerElement: '.box8',
    triggerHook: box2T,
    duration:1500,
})
if(window.innerWidth>750){
    scene8.setPin('.box8')
    scene8.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        if(index>30){
            $('.box8_title').addClass('showup')
            if(index>70){
                $('.box8_info').addClass('showup')
            }else{
                $('.box8_info').removeClass('showup')
            }
        }else{
            $('.box8_title').removeClass('showup')
        }
    })
}else{
    scene8.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        if(index>10){
            $('.box8_title').addClass('showup')
            $('.box8_info').addClass('showup')
        }else{
            $('.box8_title').removeClass('showup')
            $('.box8_info').removeClass('showup')
        }
    })
}

let scene9 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box8_1',
    triggerHook: 'onenter',
    duration:0,
})
scene9.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box9_title').addClass('showup')
    if(index<2){
        $('.box9_title').removeClass('showup')
    }
})

let scene9_1 = new ScrollMagic.Scene({
    offset: 40,
    triggerElement: '.box9_1',
    triggerHook: 'onenter',
    duration:0,
})
scene9_1.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box9_img1').css({transform:'translate(0,0)'})
    if(index<2){
        $('.box9_img1').css({transform:'translate(-20rem,17rem)'})
    }
})

let scene9_2 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box9_1',
    triggerHook: '0',
    duration:1500,
})
if(window.innerWidth>750){
    scene9_2.setPin('.box9_1')
    scene9_2.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        if(index>5){
            if(index<85){
                $('.box9_text').css({transform:`translate(${mapValue(index,5,85,7,-120)}rem)`})
            }else{
                $('.box9_text').css({transform:`translate(-120rem)`})
            }
        }else{
            $('.box9_text').css({transform:`translate(7rem)`})
        }
    })
}

let scene10 = new ScrollMagic.Scene({
    offset: -50,
    triggerElement: '.box10',
    triggerHook: '0',
    duration:600,
})
if(window.innerWidth>750){
    scene10.setPin('.box10')
}

let scene11 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box11',
    triggerHook: 'onenter',
    duration:600,
})
scene11.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    if(index>5){
        $('.box11_icon').css({transform:'translateY(0)'})
        $('.box11_logo').addClass('showup')
        if(window.innerWidth>750){
            if(index>70){
                $('.boxSpecs').addClass('showup')
            }else{
                $('.boxSpecs').removeClass('showup')
            }
        }
    }else{
        $('.box11_icon').css({transform:'translateY(22rem)'})
        $('.box11_logo').removeClass('showup')
    }
})


controller1.addScene([scene2,scene3,scene4,scene4_1,scene5,scene6,scene7_1,scene7,scene8,scene9,scene9_1,scene9_2,scene10,scene11]); 


//box8
new Swiper('.box8Swiper', {
	autoplay: true,
    pagination: {
        el: '.box8Swiper-pagination',
        clickable:true
    }
})


//box10
new Swiper('.box10Swiper', {
	effect: 'fade',
    pagination: {
        el: '.box10Swiper-pagination',
        clickable:true 
    },
    autoplay: {
        disableOnInteraction: false,
    },
})


//box3

var index = 1;
$('.box3_right').click(function(){
    clearInterval(vprimeFlag)
    if(index<8){
        index++
        $('.box3_img img').css({opacity:'0'})
        $(`.box3_img img:nth-child(${index})`).css({opacity:'1'})
        $('.box3_halo img').css({opacity:'0'})
        $(`.box3_halo img:nth-child(${index})`).css({opacity:'1'})
        $('.box3_text div').hide()
        $(`.box3_text div:nth-child(${index})`).show()
        $(`.box3_points div:nth-child(${index})`).addClass('box3_active')
        if(index==2){
            $('.box3_path1').css({clipPath:'inset(0% 0% 84% 50%)'})
        }else if(index==3){
            $('.box3_path1').css({clipPath:'inset(0% 0% 52% 50%)'})
        }else if(index==4){
            $('.box3_path1').css({clipPath:'inset(0% 0% 16% 50%)'})
        }else if(index==5){
            $('.box3_path1').css({clipPath:'inset(0% 0% 0% 50%)'})
        }else if(index==6){
            $('.box3_path2').css({clipPath:'inset(84% 50% 0% 0)'})
        }else  if(index==7){
            $('.box3_path2').css({clipPath:'inset(48% 50% 0% 0)'})
        }else  if(index==8){
            $('.box3_path2').css({clipPath:'inset(17% 50% 0% 0)'})
        }
    }
})
$('.box3_left').click(function(){
    clearInterval(vprimeFlag)
    if(index>1){
        $(`.box3_points div:nth-child(${index})`).removeClass('box3_active')
        index--
        $('.box3_img img').css({opacity:'0'})
        $(`.box3_img img:nth-child(${index})`).css({opacity:'1'})
        $('.box3_halo img').css({opacity:'0'})
        $(`.box3_halo img:nth-child(${index})`).css({opacity:'1'})
        $('.box3_text div').hide()
        $(`.box3_text div:nth-child(${index})`).show()
        if(index==1){
            $('.box3_path1').css({clipPath:'inset(0% 0% 100% 50%)'})
        }else if(index==2){
            $('.box3_path1').css({clipPath:'inset(0% 0% 84% 50%)'})
        }else if(index==3){
            $('.box3_path1').css({clipPath:'inset(0% 0% 52% 50%)'})
        }else if(index==4){
            $('.box3_path1').css({clipPath:'inset(0% 0% 16% 50%)'})
        }else if(index==5){
            $('.box3_path1').css({clipPath:'inset(0% 0% 0% 50%)'})
            $('.box3_path2').css({clipPath:'inset(100% 50% 0% 0)'})
        }else if(index==6){
            $('.box3_path2').css({clipPath:'inset(84% 50% 0% 0)'})
        }else  if(index==7){
            $('.box3_path2').css({clipPath:'inset(48% 50% 0% 0)'})
        }
    }
})

$('.box3_points div').click(function(){
    clearInterval(vprimeFlag)
    var pIndex = $(this).index()+1

    index = pIndex
    $('.box3_img img').css({opacity:'0'})
    $(`.box3_img img:nth-child(${index})`).css({opacity:'1'})
    $('.box3_halo img').css({opacity:'0'})
    $(`.box3_halo img:nth-child(${index})`).css({opacity:'1'})
    $('.box3_text div').hide()
    $(`.box3_text div:nth-child(${index})`).show()
    for(let i=1;i<index+1;i++){
        $(`.box3_points div:nth-child(${i})`).addClass('box3_active')
    }
    for(let i=index+1;i<9;i++){
        $(`.box3_points div:nth-child(${i})`).removeClass('box3_active')
    }
    if(pIndex<6){
        if(pIndex==1){
            $('.box3_path1').css({clipPath:'inset(0% 0% 100% 50%)'})
            $('.box3_path2').css({clipPath:'inset(100% 50% 0% 0)'})
        }else if(pIndex==2){
            $('.box3_path1').css({clipPath:'inset(0% 0% 84% 50%)'})
            $('.box3_path2').css({clipPath:'inset(100% 50% 0% 0)'})
        }else if(pIndex==3){
            $('.box3_path1').css({clipPath:'inset(0% 0% 52% 50%)'})
            $('.box3_path2').css({clipPath:'inset(100% 50% 0% 0)'})
        }else if(pIndex==4){
            $('.box3_path1').css({clipPath:'inset(0% 0% 16% 50%)'})
            $('.box3_path2').css({clipPath:'inset(100% 50% 0% 0)'})
        }else if(pIndex==5){
            $('.box3_path1').css({clipPath:'inset(0% 0% 0% 50%)'})
            $('.box3_path2').css({clipPath:'inset(100% 50% 0% 0)'})
        }
    }else{
        if(pIndex==6){
            $('.box3_path1').css({clipPath:'inset(0% 0% 0% 50%)'})
            $('.box3_path2').css({clipPath:'inset(84% 50% 0% 0)'})
        }else if(pIndex==7){
            $('.box3_path1').css({clipPath:'inset(0% 0% 0% 50%)'})
            $('.box3_path2').css({clipPath:'inset(48% 50% 0% 0)'})
        }else if(pIndex==8){
            $('.box3_path1').css({clipPath:'inset(0% 0% 0% 50%)'})
            $('.box3_path2').css({clipPath:'inset(17% 50% 0% 0)'})
        }
    }
})


var vprimeFlag;
function vprimeStart(){
    vprimeFlag =  setInterval(autoPlay,2000)
}
vprimeStart()


function autoPlay(){
    if(index<8){
        index++
    }else{
        index = 1
    }
    $('.box3_img img').css({opacity:'0'})
    $(`.box3_img img:nth-child(${index})`).css({opacity:'1'})
    $('.box3_halo img').css({opacity:'0'})
    $(`.box3_halo img:nth-child(${index})`).css({opacity:'1'})
    $('.box3_text div').hide()
    $(`.box3_text div:nth-child(${index})`).show()
    $(`.box3_points div:nth-child(${index})`).addClass('box3_active')
    if(index==1){
        $('.box3_path1').css({clipPath:'inset(0% 0% 100% 50%)'})
        $('.box3_path2').css({clipPath:'inset(100% 50% 0% 0)'})
    }else if(index==2){
        $('.box3_path1').css({clipPath:'inset(0% 0% 84% 50%)'})
    }else if(index==3){
        $('.box3_path1').css({clipPath:'inset(0% 0% 52% 50%)'})
    }else if(index==4){
        $('.box3_path1').css({clipPath:'inset(0% 0% 16% 50%)'})
    }else if(index==5){
        $('.box3_path1').css({clipPath:'inset(0% 0% 0% 50%)'})
    }else if(index==6){
        $('.box3_path2').css({clipPath:'inset(84% 50% 0% 0)'})
    }else  if(index==7){
        $('.box3_path2').css({clipPath:'inset(48% 50% 0% 0)'})
    }else  if(index==8){
        $('.box3_path2').css({clipPath:'inset(17% 50% 0% 0)'})
    }
}

new Swiper('.box3swiper', {
	effect: 'fade',
    loop:true,
    autoplay:true,
    pagination: {
        el: '.box3_icon',
        clickable: true,
        renderBullet: function (index, className) {
        switch(index){
            case 0:color='#33cab9';break;
            case 1:color='#8e48ef';break;
            case 2:color='#fbd91f';break;
            case 3:color='#a16c4c';break;
            case 4:color='#5168ab';break;
            case 5:color='#eeb1c0';break;
            case 6:color='#383838';break;
            case 7:color='#000';break;
        }
        return '<span class="' + className + '" style="background:'+color+'"></span>';
        },
    },
})

//box4
$('.box4_btn div').click(function(){
    $('.box4_btn div').removeClass('box4_active')
    $(this).addClass('box4_active')
    var index = $(this).index()+1
    $('.box4_video video').hide()
    $(`.box4_video video:nth-child(${index})`).show()
})
$('.box4_btn1 div').click(function(){
    $('.box4_btn1 div').removeClass('box4_active')
    $(this).addClass('box4_active')
    var index = $(this).index()+1
    $('.box4_img2 img').hide()
    $(`.box4_img2 img:nth-child(${index})`).show()
})

//box5
// $('.box5_info2 div').click(function(){
//     var index = $(this).index()+1
//     $('.box5_bg div').hide()
//     $(`.box5_bg div:nth-child(${index})`).show()
//     $('.box5_info2 div').removeClass('box5_active')
//     $(this).addClass('box5_active')
// })


//boxSpecs_btn
$('.boxSpecs_btn').click(function(){
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_buy').click(function(){ 
    window.open('https://store.oxva.com/products/oxva-vprime-kit'); 
})

$('.pnr_spec').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_over2').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section2').hide()
    $('.classic_section1').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
})

$('.box2_items div').click(function(){
    var index = $(this).index()+1
    if(index == 1){
        var element = document.querySelector(".box4");
        element.scrollIntoView({block: "start"});
    }else if(index == 2){
        var element = document.querySelector(".box7_1");
        element.scrollIntoView({block: "start"});
    }else if(index == 3){
        var element = document.querySelector(".box5");
        element.scrollIntoView({block: "start"});
    }else if(index == 4){
        var element = document.querySelector(".box8");
        element.scrollIntoView({block: "start"});
    }
})